import React, { useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Divider, EnumHelperText, HelperText, Tabs, Typography } from 'shared/ui'
import { type IChatbotMessage } from 'entities/Chatbot/model/type'
import { MessageField } from 'widgets/MessageField'
import { useChatbotContext } from 'pages/chatbot/context'

import styles from './styles.module.scss'

export const FirstMessage = observer(() => {
  const isDirty = useRef(false)
  const {
    errors,
    message,
    setDraggingCondition,
    model: { firstMessage },
  } = useChatbotContext()
  const { conversationType, setConversationType, tabs, isAutoConvType } = firstMessage

  const messageError = errors.getError('first_message.message')

  useEffect(() => {
    if (isDirty.current) errors.removeError('first_message')

    isDirty.current = true
  }, [message.field.messageText])

  useEffect(() => message.syncMessage(), [])

  useEffect(() => {
    if (!!messageError) message.field.setHighlight('error')
    else message.field.clearHighlight()
  }, [messageError])

  return (
    <div className={styles.message}>
      <div className={styles.tabs}>
        <Tabs
          variant={'simpleWithoutBorder'}
          tabs={tabs}
          activeTabKey={conversationType}
          handleSelectTab={({ key }) => setConversationType(key as IChatbotMessage['type'])}
        />
        <Divider style={{ marginTop: '8px' }} />
      </div>

      {isAutoConvType ? (
        <>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'continueConv_message'}
            color={'var(--content-primary-tertiary)'}
            marginTop={14}
            marginBottom={24}
          >
            AI Agent will continue conversations naturally based on past messages, or initiate new
            conversations when no prior context exists.
          </Typography>
          <Divider />
        </>
      ) : (
        <>
          <div>
            <div className={styles.alerts} ref={message.field.setAlertElement} />
            <MessageField messageFieldStore={message.field} onDragHandler={setDraggingCondition} />
          </div>
          {!!messageError && (
            <HelperText
              icon={'alertTriangleSmall'}
              variant={EnumHelperText.Error}
              text={messageError}
            />
          )}
        </>
      )}
    </div>
  )
})
